import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center">
      <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
        <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
          For the love of{' '}
          <span className="bg-gradient-to-r from-pink-500 to-teal-400 bg-clip-text text-transparent inline">
            time
          </span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
          Cut through the chaos of traditional calendars with simple, natural language–driven timelines. 
        </p>
      </div>
    </section>
  );
};

export default Hero;
